import Form from "../../../../components/forms/form/index";
import { useEffect, useState } from "react";
import url from "../../../../config/axios";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const FarmingUpdate = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [loading, setLoading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [shopCategoryone, setShopCategoryone] = useState();
  const { id } = useParams();

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const onDrop = async (acceptedFiles) => {
    try {
       setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    }  finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    marketPlace: "",
    shopCategory: categoryid,
    businessType: "farmingShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setLoading(true);
    url
      .get(`shop/id?id=${id}`)
      .then(async (response) => {
        if (response.data.success) {
          setLoading(false);
          setCreateShop(response?.data?.data?.Shop);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  }, []);

  useEffect(() => {
    url
      .get("category/type/?type=farmingShop&parentCategory=")
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategoryone(response?.data?.data?.Category);
        }
      })
      .catch((error) => { });
  }, []);

  const UpdateShop = (e) => {
    setLoading(true);
    e.preventDefault();
    url
      .put(`shop/id?id=${id}`, createShop)
      .then(async (response) => {
        if (response?.data?.success) {
          setLoading(false);
          setTimeout(() => {
            SuccessNotify("Form Update Successfully");
            navigate("/farming-profile/" + id);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoading(false);
        FailedNotify("Failed to Update");
      });
  };

  if (loading) {
    return <Loader heightsetting="screenHeight" />;
  }
  return (
    <Form
      title="Fill to Update Farming Shop"
      butn="Update"
      navigateTo="/farming-profile"
      back="/farming-profile/"
      UpdateShop={UpdateShop}
      shopCategoryone={shopCategoryone}
      createShop={createShop}
      setCreateShop={setCreateShop}
      link="/farming-update/"
      id={id}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      Shopdatas={Shopdatas}
      isUploading={isUploading}           
uploadProgress={uploadProgress}
    />
  );
};
export default FarmingUpdate;
